<template>
  <tr class="ignored bg-orange-200/30 text-sm child:py-3 first-child:pl-3 last-child:pr-3">
    <td class="text-left">
      <AppInput
        v-model="description"
        name="description"
        type="text"
        class="w-full form-input h-8"
        placeholder="Description"
        @blur="trySave"
        @keyup.enter="trySave()"
      />
    </td>

    <td class="text-right">
      <AppCurrencyInput
        v-model.number="finalAmount"
        name="final_amount"
        type="number"
        class="w-28 h-8 ml-auto form-input"
        @blur="trySave"
        @keyup.enter="$event.target.blur()"
      />
    </td>

    <td />

    <td />

    <td />

    <td />

    <td v-if="showPercentages" />

    <td v-if="showPercentages" />

    <td v-if="showPercentages" />

    <td v-if="showForecasts" />

    <td v-if="ratesColumn" />

    <td />

    <td />

    <td class="text-right">
      <AppInput
        v-model.number="forecastPercent"
        name="forecast_percent"
        type="number"
        min="0"
        max="100"
        step="0.01"
        class="w-24 h-8 ml-auto form-input"
        placeholder="%"
        @focus="percentFocused = true"
        @blur="percentFocused = false; trySave()"
        @keyup.enter="$event.target.blur()"
      />
    </td>

    <td class="text-right">
      <div class="flex items-center justify-end gap-1">
        <AppCurrencyInput
          v-model.number="forecastAmount"
          name="forecast_amount"
          type="number"
          class="w-28 h-8 ml-auto form-input"
          @focus="amountFocused = true"
          @blur="amountFocused = false; trySave()"
          @keyup.enter="$event.target.blur()"
        />

        <button
          type="button"
          class="btn-icon btn-icon-red"
          title="Remove row"
          @click="emit('removed')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
        </button>
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { roundDecimals } from '@/helpers';
import { useScopeGapItemsStore } from '@/store/scopeGapItems';
import { ref, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    projectId: string;
    packageId: string;
    canEdit: boolean;
    showPercentages?: boolean;
    showForecasts?: boolean;
    ratesColumn?: boolean;
  }>(),
  {
    showPercentages: false,
    showForecasts: false,
    ratesColumn: false,
  },
);

const emit = defineEmits<{
  (e: 'saved'): void;
  (e: 'removed'): void;
}>();

const scopeGapItemsStore = useScopeGapItemsStore();
const storeScopeGapItemAction = useStoreApiAction(scopeGapItemsStore.store);
const description = ref('');
const finalAmount = ref<number | undefined>();
const forecastPercent = ref<number | undefined>();
const forecastAmount = ref<number | undefined>();
const percentFocused = ref(false);
const amountFocused = ref(false);
const saving = ref(false);

function isComplete(): boolean {
  return description.value.trim().length > 0 &&
    finalAmount.value !== undefined &&
    forecastAmount.value !== undefined;
}

watch(forecastPercent, (newValue) => {
  if(!percentFocused.value || amountFocused.value) return;
  if(finalAmount.value === undefined || newValue === undefined) return;

  forecastAmount.value = roundDecimals(finalAmount.value * (newValue / 100));
});

watch(forecastAmount, (newValue) => {
  if(!amountFocused.value || percentFocused.value) return;
  if(finalAmount.value === undefined || newValue === undefined) return;
  if(finalAmount.value <= 0) return;

  forecastPercent.value = roundDecimals((newValue / finalAmount.value) * 100);
});

function trySave() {
  if(!props.canEdit || saving.value || !isComplete()) return;

  saving.value = true;

  storeScopeGapItemAction.request(props.projectId, props.packageId, {
    description: description.value.trim(),
    final_amount: finalAmount.value,
    forecast_amount: forecastAmount.value,
  }).then((data) => {
    emit('saved');
  }).catch(() => {
    saving.value = false;
  });
}
</script>
